// Firebase configuration for frontend - Lazy loaded for better performance
import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getAnalytics, logEvent } from 'firebase/analytics';

// Firebase config
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBwn_IiGntnW5Fbdmx3zcTk5hItKqR8wWg",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "bhuvi-admin.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "bhuvi-admin",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "bhuvi-admin.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "3522387404",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:3522387404:web:074fd8a706cd86fa4e5169",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-PJBLNRNFMK"
};

// Initialize Firebase only if not already initialized
let app = null;
let auth = null;

try {
  if (getApps().length === 0) {
    app = initializeApp(firebaseConfig);
  } else {
    app = getApps()[0];
  }

  // Initialize Firebase Authentication
  if (app) {
    auth = getAuth(app);
  }
} catch (error) {
  console.error('❌ Firebase initialization error:', error);
  console.error('Error details:', error.message, error.stack);
  // auth will remain null, components should handle this
}

// Initialize Firebase Storage
let storage = null;
try {
  if (app) {
    storage = getStorage(app);
  }
} catch (error) {
  console.error('❌ Firebase Storage initialization error:', error);
}

export { auth, storage };

// Initialize Firebase Analytics lazily (deferred for better performance)
let analytics = null;
let analyticsInitialized = false;

// Lazy initialize analytics after page load
const initializeAnalytics = () => {
  if (analyticsInitialized || typeof window === 'undefined' || !firebaseConfig.measurementId || !app) {
    return;
  }
  
  try {
    analytics = getAnalytics(app);
    analyticsInitialized = true;
  } catch (error) {
    // Analytics initialization failed, continue without it
    console.warn('Analytics initialization failed:', error);
  }
};

// Initialize analytics after page load (non-blocking)
if (typeof window !== 'undefined') {
  if (document.readyState === 'complete') {
    // Page already loaded, initialize after a delay
    setTimeout(initializeAnalytics, 1000);
  } else {
    // Wait for page load
    window.addEventListener('load', () => {
      setTimeout(initializeAnalytics, 1000);
    }, { once: true });
  }
}

// Helper function to log analytics events
export const logAnalyticsEvent = (eventName, eventParams = {}) => {
  if (analytics) {
    try {
      logEvent(analytics, eventName, eventParams);
    } catch (error) {
      // Silently fail if analytics logging fails
    }
  }
};

export { analytics };
export default app;

